// @ts-nocheck 3eeda7c1
import * as addPanel from '#packages/oldAddPanel';

export default {
  getDesignSections() {
    return {
      titles: [],
      sections: [
        addPanel.sections.getSections().other.fileDownloadButtonsSection,
      ],
    };
  },
};
